export {};
declare global {
    interface String {
        capitalizeFirstLetter(): string;

        isEmpty(): boolean;

        equalsIgnoreCase(otherString: string): boolean;
    }
}

String.prototype.capitalizeFirstLetter = function() {
    return this.charAt(0).toUpperCase() + this.slice(1).toLocaleLowerCase();
};

String.prototype.isEmpty = function() {
    return this.trim().length === 0;
};

String.prototype.equalsIgnoreCase = function(otherString) {
    return (this.toLocaleLowerCase() === otherString.toLocaleLowerCase());
};
